export const SOFTLINE_FEATURE_LAGERKORREKTUR = 'lagerkorrektur';

export const SOFTLINE_PERMISSION_LAGERKORREKTUR = 'SOFTAPPS.LAGER.LAGERKORREKTUR';
